import React, { useState } from 'react';
import styled from 'styled-components';
import Navigation from 'components/soulx/Navigation';
import Header from 'components/soulx/header';
import Video from 'components/soulx/Video';
import Footer from 'components/soulx/Footer';
import '../../typography.css'; // 이미 있는 임포트
// Main container styled component
const MainContainer = styled.div`
  display: flex;  // Ensure it's a flex container
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #000000;
  background-image: url('/images/Back.png'); // Add your background image path here
  background-size: cover; // Cover the entire container
  background-position: center; // Center the image
  min-height: 100vh; // Ensure it covers the full height of the viewport
  overflow: hidden; // Prevents horizontal scroll
    @media (max-width: 1024px) {
    background-image: url('/images/Back2.png'); // Add your background image path here
}
    @media (max-width: 768px) {
    background-image: url('/images/Back3.png'); // Add your background image path here
  
}
`;
const GradientSpace = styled.div`
width:100%;
height:484px;
  background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%);
position: absolute;  // 절대 위치로 설정
  @media (max-width: 768px) {
   display: none;
  }
`;
const LangButton = styled.button`
  color: white;
  font-size: 18px;
  cursor: pointer;
  margin: 0;
  text-decoration: underline;
  transition: color 0.3s ease, background-color 0.3s ease;
  z-index: 10;  // Ensure it's clickable by placing it in front

  // Tablet and larger screens
  @media (max-width: 1024px) {
    font-size: 16px;
  }

  // Mobile screens
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Spacer = styled.div`
  position: relative;  // Make sure it's positioned correctly
  z-index: 1;  // Set a lower z-index than LangButton to prevent overlap issues
  margin-top: 108px;
  margin-right: 25px;
  display: flex;
  justify-content: flex-end;
  width: 1252px;

  @media (max-width: 1024px) {
    width: 100%;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 76px;
    margin-right: 20px;
  }
`;


// Styled component for the logo
const Logo = styled.img`
  margin-top: 20px; // Fixed to lowercase 'm'
  width: 120px; // Default width for desktop
  height: 150px; // Maintain aspect ratio
  display: flex; // Allow content to be aligned
    z-index: 1;  // Set a lower z-index than LangButton to prevent overlap issues
  margin-bottom: 44px; // Fixed to lowercase 'm'
  // Tablet screens
  @media (max-width: 1024px) {
    margin-top: 28px; // Fixed to lowercase 'm'
    width: 100px; // Default width for tablet
    height: 124px; // Maintain aspect ratio'
    margin-bottom: 58px; // Fixed to lowercase 'm'
  }

  // Mobile screens
  @media (max-width: 768px) {
    margin-top: 20px; // Fixed to lowercase 'm'
    width: 61px; // Default width for mobile
    height: 76px; // Maintain aspect ratio
    margin-bottom: 36px; // Fixed to lowercase 'm'
  }
`;

const Main: React.FC = () => {
  const [language, setLanguage] = useState('EN'); // 기본 언어는 영어로 설정

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === 'EN' ? 'KO' : 'EN'));
  };

  return (
    <MainContainer id="Main">
      <Header language={language} />
      <GradientSpace/>
      <Spacer>
        <LangButton onClick={toggleLanguage}>
          {language === 'EN' ? 'KO' : 'EN'}
        </LangButton>
      </Spacer>

      <Logo src="/images/soulx.svg" alt="Logo" /> {/* Add your logo path here */}
      <Navigation language={language} />
      <Video language={language} />
      <Footer language={language} />
    </MainContainer>
  );
};

export default Main;
